export enum PoiProvider {
  human = 'human',
  neo4j = 'neo4j',
  parcours = 'parcours'
}
